module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6b92aada369c2fc9e71fb49064804850.png";